module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-15.50cff266.jpg";